import React, { useCallback } from 'react';

import { SummarySection, SummaryContents } from '../../styles/LandingStyles';
import InnerContainer from './InnerContainer';
import Typography from '../common/typography/Typography';

import useLanguage from '../../store/language';
import useLanguagePack from '../../hooks/useLanguagePack';

const Section2 = () => {
  const { language } = useLanguage(
    useCallback(state => ({
      language: state.language,
    }))
  );

  const languageKeyStrings = {
    title1: useLanguagePack('landing_summary_contents1_title_1'),
    text1: useLanguagePack('landing_summary_contents1_text_1'),
    title2: useLanguagePack('landing_summary_contents2_title_1'),
    text2: useLanguagePack('landing_summary_contents2_text_1'),
    title3: useLanguagePack('landing_summary_contents3_title_1'),
    text3: useLanguagePack('landing_summary_contents3_text_1'),

    newTitle1: useLanguagePack('renew_landing_5'),
    newText1: useLanguagePack('renew_landing_6'),
    newTitle2: useLanguagePack('renew_landing_7'),
    newText2: useLanguagePack('renew_landing_8'),
    newTitle3: useLanguagePack('renew_landing_9'),
    newText3: useLanguagePack('renew_landing_10'),
    newTitle4: useLanguagePack('renew_landing_11'),
    newText4: useLanguagePack('renew_landing_12'),
  };

  return (
    <SummarySection>
      <InnerContainer>
        <SummaryContents language={language}>
          <div>
            {/* <Typography variant={'T3'}>{languageKeyStrings.title1}</Typography>
            <Typography variant={'C4'}>{languageKeyStrings.text1}</Typography> */}
            <img src='/assets/image/newLanding/lading_best.png' />
            <Typography variant={'T3'} style={{whiteSpace:"nowrap"}}>{languageKeyStrings.newTitle1}</Typography>
            <Typography variant={'C4'}>{languageKeyStrings.newText1}</Typography>
          </div>
          {/* <p /> */}
          <div>
            {/* <Typography variant={'T3'}>{languageKeyStrings.title2}</Typography>
            <Typography variant={'C4'}>{languageKeyStrings.text2}</Typography> */}
            <img src='/assets/image/newLanding/lading_revenue.png' />
            <Typography variant={'T3'} style={{whiteSpace:"nowrap"}}>{languageKeyStrings.newTitle2}</Typography>
            <Typography variant={'C4'}>{languageKeyStrings.newText2}</Typography>
          </div>
          {/* <p /> */}
          <div>
            {/* <Typography variant={'T3'}>{languageKeyStrings.title3}</Typography>
            <Typography variant={'C4'}>{languageKeyStrings.text3}</Typography> */}
            <img src='/assets/image/newLanding/lading_upload.png' />
            <Typography variant={'T3'} style={{whiteSpace:"nowrap"}}>{languageKeyStrings.newTitle3}</Typography>
            <Typography variant={'C4'}>{languageKeyStrings.newText3}</Typography>
          </div>
          {/* <p /> */}
          <div>
            {/* <Typography variant={'T3'}>{languageKeyStrings.title3}</Typography>
            <Typography variant={'C4'}>{languageKeyStrings.text3}</Typography> */}
            <img src='/assets/image/newLanding/lading_world.png' />
            <Typography variant={'T3'} style={{whiteSpace:"nowrap"}}>{languageKeyStrings.newTitle4}</Typography>
            <Typography variant={'C4'}>{languageKeyStrings.newText4}</Typography>
          </div>
        </SummaryContents>
      </InnerContainer>
    </SummarySection>
  );
};

export default Section2;
